'use client';
import { Search } from './search.js';
import { SearchButton } from './search-button.js';
import { SearchClear } from './search-clear.js';
import { SearchInput } from './search-input.js';

/**
 * Search component, use to display different variations of a search input
 *
 * @example with button
 * <Search>
 *   <Search.Input aria-label='Søk' />
 *   <Search.Clear />
 *   <Search.Button />
 * </Search>
 *
 * @example with icon
 * <Search>
 *   <Search.Input aria-label='Søk' />
 *   <Search.Clear />
 * </Search>
 */
const SearchComponent = Object.assign(Search, {
    Clear: SearchClear,
    Button: SearchButton,
    Input: SearchInput,
});
SearchComponent.Clear.displayName = 'Search.Clear';
SearchComponent.Button.displayName = 'Search.Button';
SearchComponent.Input.displayName = 'Search.Input';

export { SearchComponent as Search, SearchButton, SearchClear, SearchInput };
